export function OrBorder() {
  return (
    <div className="my-4 flex max-w-md items-center gap-2">
      <div className="h-px flex-grow bg-stroke-line"></div>
      <p className="text-gray-500 text-sm">or</p>
      <div className="h-px flex-grow bg-stroke-line"></div>
    </div>
  );
}
